import '../css/guest.css';
import.meta.glob(['../images/**'], { eager: true });
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.tsx';
import type { AppProps } from './types/app.types';
import AppToaster from './components/ui/AppToaster';
import { LoaderProvider } from './context/loader/LoaderProvider';
import { loadTranslations } from './i18n';
function readProps(element: HTMLElement): AppProps {
    const raw = element.getAttribute('data-props');

    if (!raw)
        return {
            user: undefined,
        };

    try {
        return JSON.parse(raw) as AppProps;
    } catch {
        return {
            user: undefined,
        };
    }
}

const root = document.getElementById('app');

if (root) {
    const props = readProps(root);
    const hideHeaderValue = props.hide_header;
    const shouldHideHeader = hideHeaderValue === '1' || hideHeaderValue === 1 || hideHeaderValue === true;

    if (props?.user?.api_token) {
        localStorage.setItem('token', props.user.api_token);
    }
    void loadTranslations(props.locale);

    ReactDOM.createRoot(root).render(
        <React.StrictMode>
            <LoaderProvider>
                <BrowserRouter>
                    <AppToaster />
                    <App {...props} hide_header={shouldHideHeader} />
                </BrowserRouter>
            </LoaderProvider>
        </React.StrictMode>,
    );
}
